module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-brands-400.7c0be8b6.woff2";